import React from 'react'
import Container from '../../components/Container'
import FormDeposit from '../../components/FormDeposit'

import './index.scss'

const Order = () => {
    return (
        <div className="order">
            <Container>
                <div className="order__title medium">
                    Заявка на депозит
                </div>
                <div className="order__form">
                    <FormDeposit />
                </div>
            </Container>
        </div>
    )
}

export default Order